var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apply-header-picture"},[_c('img',{staticClass:"lazyload",attrs:{"data-src":_vm.imageUrl,"alt":"STIHL All Inclusive"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }